import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { FEEDBACK } from "root/profile/ProfileRouter.config";
import { useLastFeedback } from "./useLastFeedback";

const OpenLastFeedbackButton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { last } = useLastFeedback();

  // Don't show the button if no recent feedback chat
  if (!last?.relatedTo) {
    return null;
  }

  const handleClick = () => {
    navigate(FEEDBACK.url(), {
      state: {
        relatedTo: {
          text: last.relatedTo
        }
      }
    });
  };

  return (
    <Button variant="text" fullWidth color="primary" onClick={handleClick}>
      {t("Continue last chat")}
    </Button>
  );
};

export default OpenLastFeedbackButton;
